<template>
<b-container
  class="py-5 d-flex section"
  fluid
  >
  <b-row class="justify-content-center align-self-center mx-auto">
    <b-col>
      
      <b-container fluid>
	<b-row>
	  <b-col>
	    <div class="text-center pb-4">
	      <h1>TrinApps - a family of Applications</h1>
	    </div>
	  </b-col>
	</b-row>
	<b-row class="py-3">
	  <b-col
	    cols="4"
	    md="2"
	    offset-md="2"
	    >
	    <div>
	      <b-img
		:src="require('../assets/trinapps_fam.png')"
		style="min-width: 80px; 
		       max-width: 200px; 
		       width: 100%; 
		       height: auto;"
		/>
	    </div>
	  </b-col>
	  <b-col
	    cols="8"
	    md="6"
	    >
	    <div>
	      <p>TrinApps is a family of apps, developed by Graphmetrix, on top of their TrinPod<sup>&trade;</sup> technology and their Trinity Conceptual Computing and One-World model.</p>
	      
	      <p>Each TrinApp is a state-of-the-art App with unrivaled AI and ease-of-use with enterprise-level power and security.</p>
	      
	      <p>Each time you add a new TrinApp<sup>&trade;</sup> to your TrinPod<sup>&trade;</sup>, you make your other TrinApps more useful. This is because each TrinApp share the same data in the same one-world model.</p>
	      
	      <p>The more information, files, and data you have in your TrinPod<sup>&trade;</sup> and one-world model, the more powerful Trinity will be in helping you utilize all your information.</p>
	      
	      <p>The conceptual understanding and abilities of Trinity are continually growing, making each TrinApp more useful each day.</p>
	    </div>
	  </b-col>
	</b-row>
      </b-container>
      
    </b-col>
  </b-row>
</b-container>
</template>

<script>
export default {
    name: "TrinAppsFamily",
    methods: {
	img: function (image) {
	    require(image)
	}
    }
}
</script>
